export default function Logo() {
  return (
    <div>
      <img className="float-left mr-4" alt="โลโก้รัฐสภาไทย" src={"./cons60-logo.png"} />
      <span style={{lineHeight: "40px"}}>บันทึกกรธ.60</span>
    </div>
  );
}
